import * as React from "react";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  makeStyles,
  Grid,
  Typography, colors,
} from "@material-ui/core"
import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import { Tooltip } from '@material-ui/core';
import FlightBadge from "../FlightBadge/FlightBadge";
import { accentDefault, accentLight, accentUltraLight } from "../../constants/colors";
import ClientRemarkIcon from '../../assets/img/client-remark.svg';
import backgroundCrown from "../../assets/img/crown.png";

const useStyles = makeStyles(({ spacing, breakpoints: { down } }) => ({
  formControlLabelIsSold: {
    width: "100%",
    margin: 0,
    padding: spacing(0.4),
    position: "relative",
    "& p": {
      opacity: 0.3,
    },

    "& span:last-of-type": {
      width: "100%",
      minHeight: "64px",
      background: accentUltraLight,
      color: accentDefault,
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.3s ease",
      position: "relative",

      // [down("xs")]: {
      //   flexDirection: "column-reverse",
      //   "& p:last-of-type": {
      //     fontSize: "10px",
      //   },
      //   "& p:first-of-type": {
      //     fontSize: "15px",
      //   },
      // },
    },
    "& span:first-of-type": {
      color: "orange",
    },
    "& .Mui-checked + span": {
      color: "white",
      background: accentDefault,
    },

    "&:after": {
      "& span:last-of-type": {
        position: "absolute",
        content: "sold",
        top: "0",
        right: "0",
        width: "20px",
        height: "20px",
      },
    },
  },

  formControlLabelIsRecommended: {
    borderRadius: '16px',

    background: 'conic-gradient(from 180deg at 48.5% 50%, #8F653B -28.12deg, #E3A455 26.25deg, #F6DBA6 88.12deg, #FFEBC4 156.58deg, #F0BE79 191.74deg, #8F653B 213.59deg, #673D22 225.95deg, #BA7F3B 255.19deg, #EEBC70 278.6deg, #8F653B 331.88deg, #E3A455 386.25deg)',
  },
  formControlLabelIsRecommendedIcon: {
    width: '46px !important',
    height: '46px !important',
    display: 'block !important',
    minHeight: '30px !important',
    top: '-28px',
    right: '-22px',
    position: 'absolute !important',
    zIndex: 1,
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: 'contain !important',
    backgroundColor: 'transparent !important',
    padding: '0 !important',
    [down("xs")]: {
      width: '28px !important',
      height: '28px !important',
      minHeight: '28px !important',
      top: '-18px',
      right: '-13px',
    }
  },
  formControlLabel: {
    width: "100%",
    margin: 0,
    // padding: spacing(0.3),
    padding: '3px',

    "& div": {
      position: "absolute",
      bottom: "100%",
      marginBottom: "-11px",
      right: "10px",
    },
    "& span:last-of-type": {
      width: "100%",
      minHeight: "64px",
      background: accentUltraLight,
      color: accentDefault,
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.3s ease",
      position: "relative",
      padding: '8px 4px',

      [down("xs")]: {
        padding: '4px 2px',
      //   // flexDirection: "column-reverse",
      //   // "& p:last-of-type": {
      //   //   fontSize: "10px",
      //   // },
      //   // "& p:first-of-type": {
      //   //   fontSize: "15px",
      //   // },
      },
    },
    "& span:first-of-type": {
      color: "orange",
    },
    "& .Mui-checked + span": {
      color: "white",
      background: accentDefault,
    },
    "&:hover": {
      "& span:last-of-type": {
        background: accentLight,
        color: "white",
      },
    },
  },
  radioGroup: {
    flexWrap: "wrap",
    flexDirection: "row",
    width: "100%",
  },
  radio: {
    display: "none",
  },
  radioTab: {
    [down("xs")]: {
      marginBottom: "16px",
    },
  },
  formControlLabelIsSoldLabel: {
    fontSize: '10px',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    background: '#CE5D5D',
    borderRadius: '6px',
    padding: '5px 10px',
    position: 'absolute',
    bottom: '100%',
    top: 'auto',
    right: '10px',
    marginBottom: '-11px',
    zIndex: 1,
  },

  clientRemark: {
    display: 'flex',
    fontSize: '12px',
    lineHeight: '18px',
    color: 'white',
    fontWeight: 'normal',
    position: 'initial !important',
    padding: '6px 12px',
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "start",
    textAlign: 'center',
    "& img": {
      position: 'relative',
      top: 2,
      marginRight: 4
    },
    [down("xs")]: {
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '10px',
      lineHeight: '14px',
      "& img": {
        top: 0,
        marginRight: 0,
        marginBottom: 4,
      }
    }
  },
  offerPrice: {
    [down("xs")]: {
      fontSize: "15px",
    },
  },
  offerCarrier: {
    [down("xs")]: {
      fontSize: "10px",
    }
  },

  badgeIsHotel:{
    position: 'absolute',
    top: 'auto',
    bottom: '100%',
    right: '65px',
    color: 'white',
    marginBottom: '-11px',
    "& p": {
      opacity: 1,
    },
  }
}));

const RadioTabs = ({ ...props }) => {
  const classes = useStyles();
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";


  const getPriceOfferParts = (prices) => {
    for (const price of prices) {
      const stringPrice = String(price)
      if (!!stringPrice && stringPrice.includes('.')) {
        const split = stringPrice.split('.')
        return {
          amount: split[0],
          cents: split[1]
        }
      } else {
        return {
          amount: stringPrice,
          cents: '00'
        }
      }
    }
  }

  return (
    <>
      <Controller
        {...props}
        as={

          <RadioGroup aria-label="flight" className={classes.radioGroup}>
            {props.options.map((option, index) => (
              <Grid
                item
                xs={4}
                // sm={4}
                className={classes.radioTab}
                key={index}
              >
                <Tooltip
                  title="Recomended"
                  enterDelay={100}
                  leaveDelay={100}
                  disableHoverListener={!option.recommendedOption || option.is_sold}
                  disableTouchListener={!option.recommendedOption || option.is_sold}
                  placement={'top'}
                >
                  <FormControlLabel
                    key={index}
                    className={`${option.is_sold ? classes.formControlLabelIsSold : classes.formControlLabel} ${option.recommendedOption && !option.is_sold && classes.formControlLabelIsRecommended}`}
                    disabled={option.is_sold}
                    value={`${option?.id}`}
                    control={<Radio className={classes.radio} />}
                    label={
                      <>
                        {option.recommendedOption && !option.is_sold ? <span
                          className={classes.formControlLabelIsRecommendedIcon}
                          style={{ backgroundImage: `url(${backgroundCrown})` }}
                        ></span> : null}

                        {option.is_sold ? <div className={classes.formControlLabelIsSoldLabel}>Sold</div> : null}

                        <Typography variant="body1" className={classes.offerCarrier}>
                          {props?.airlines[option?.validatingCarrier]?.name}
                        </Typography>

                        <Typography variant="body2" className={classes.offerPrice}>
                          {`$${getPriceOfferParts([option.priceOfferPerOne, option.priceOffer]).amount}`}
                          <small>{`.${getPriceOfferParts([option.priceOfferPerOne, option.priceOffer]).cents}`}</small>
                        </Typography>

                        {option.id === props.selectedFlight?.id && option?.clientRemark ?
                          <Typography className={classes.clientRemark}>
                            {<img src={ClientRemarkIcon} alt="remark"/>}
                            {option?.clientRemark}
                          </Typography> : null
                        }

                        {option?.badge && option.is_sold ?
                          <div className={classes.badgeIsHotel}><FlightBadge info={option.badge}/>
                          </div> : option?.badge && <FlightBadge info={option.badge}/>}
                      </>
                    }
                  />
                </Tooltip>
              </Grid>
            ))}
          </RadioGroup>
        }
        control={control}
      />
      <FormHelperText>
        {errorText ? errorText : props.helperText}
      </FormHelperText>
    </>
  );
};

export default RadioTabs;
